import { Component, inject } from '@angular/core';
import { EbbaButton } from '../ebba-button/ebba-button';
import { InlineMovingText } from '../inline-moving-text/inline-moving-text';
import { ResponsiveService } from '../../../core/services/responsive.service';

@Component({
  selector: 'app-landing-hero',
  imports: [EbbaButton, InlineMovingText],
  templateUrl: './landing-hero.html',
  styleUrl: './landing-hero.css',
})
export class LandingHero {
  responsiveCheck = inject(ResponsiveService);
}
